import AccordionLayoutWeb from './AccordionLayout.web';
import AccordionLayoutMobile from './AccordionLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? AccordionLayoutMobile : AccordionLayoutWeb;
